import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import {
  Injectable
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalstorageService } from './storage/localstorage.service';
import { AuthenticatorService } from './authenticator/authenticator.service';
// import { ErrorPopupComponent } from '../components/shared/error-popup/error-popup/error-popup.component';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private errorPopupSubject: BehaviorSubject<any> = new BehaviorSubject<any>({show:false,message:''});
  loading$ = this.loadingSubject.asObservable();
  errorPopup$ = this.errorPopupSubject.asObservable();

  constructor(
    public http: HttpClient,
    private localStorage: LocalstorageService,
    private APIauth: AuthenticatorService
    // private errorComponent: ErrorPopupComponent
  ) { }

  showLoading() {
    this.loadingSubject.next(true);
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }

  showError(message:any){
    this.errorPopupSubject.next({show:true,message:message})
  }
  
  public async getFromApi(funcao: string, metodo: string, dados: any, callbackfunction: any, ShowLoading: boolean, ApiUrl: string) {
    
    // dados.acessos = JSON.parse(this.localStorage.getData("ACCESSDATA")); comentei essas linha porque estava retornando uma key vazia nos JSONs 19/4/2024 - zz
    return new Promise((resolve, reject)=> {

      this.http.get("assets/config.json?" + Math.random()).subscribe( async data => {
        let url = JSON.parse(JSON.stringify(data))
        let mostraRetorno = url.mostraRetorno
        ApiUrl = url.urlBackend;
        var token = url.token;
        var client_key = url.tokenAuthenticator
        if (ApiUrl.charAt(ApiUrl.length - 1) == '/') {
          ApiUrl = ApiUrl.slice(0, -1);
        }

        url = ApiUrl + "/" + funcao + "/" + metodo;

        const httpOption = {}
        var PopupAction = false;
        if(dados.action != null && dados.action != undefined && dados.action != '' ){
          if( dados.action == 'importaNotaEntrada' || dados.action == 'integracaoPorTipo' || dados.action == 'visualizarDanfeArq'){
            PopupAction = true;
            const httpOption = {
              headers: new HttpHeaders({
                Authorization: token
              })
            }
          }else{
            const httpOption = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: token
              })
            }
          }
        }else{
          if(metodo == 'enviarCertificado' || metodo == 'carregarLogotipo'){
            const httpOption = {
              headers: new HttpHeaders({
                Authorization: token
              })
            }
          }else{
            const httpOption = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: token
              })
            }
          }
        }

        // no api serviçe eu percorro o storage e preencho os cookies -> será q n ta passando antes de receber os cookies, do storage?, nao eu conferi
        var cookies = await JSON.parse(this.localStorage.getData('PERMISSOES'));
        var versao = await JSON.parse(this.localStorage.getData('VERSAO'));
        var token = await JSON.parse(this.localStorage.getData('SESSION'));
        
        dados.cookie = {
          nom_usuario       : cookies.nom_usuario,
          administrador     : cookies.administrador,
          cod_usuario       : cookies.cod_usuario,
          email_usuario     : cookies.email_usuario,
          login             : cookies.login,
          cod_empresa       : cookies.cod_empresa,
          id_nfer_empresa_k : cookies.id_nfer_empresa_k,
          cod_estab         : cookies.cod_estab,
          den_empresa       : cookies.den_empresa,
          manter            : cookies.manter,
          ValidatedResource : cookies.scalar,
          versao            : versao
        }

        dados.token = token;
        dados.client_key = client_key;

        if(PopupAction){

          var dadosControle:any = {
            cookie : dados.cookie,
            action : dados.action,
            dados  : '',
            token  : dados.token,
            client_key : client_key
          }

          var requestData = new FormData();
          if( dados.action == 'integracaoPorTipo'){
            requestData.append('file', dados.dados.file, dados.dados.file.name );
            dadosControle.dados = dados.dados.tipo;
          }else{
            requestData.append('file', dados.dados, dados.dados.name );
          }

          dadosControle = JSON.stringify(dadosControle);
          requestData.append('dados', dadosControle);
          dados = requestData
        }

        var dadosControle:any = {
          cookie : dados.cookie,
          token  : dados.token,
          client_key : client_key
        }

        if(metodo == 'enviarCertificado'){
          dadosControle = JSON.stringify(dadosControle);
          var requestData = new FormData();
          requestData.append('CertFile', dados.CertFile, dados.CertFile.name );
          requestData.append('dados', dadosControle);
          dados = requestData;
        }

        if(metodo == 'carregarLogotipo'){
          dadosControle = JSON.stringify(dadosControle);
          var requestData = new FormData();
          requestData.append('logo_empresa', dados.logotipo, dados.logotipo.name );
          requestData.append('dados', dadosControle);
          dados = requestData;
        }

        if (!navigator.onLine) {
          Promise.reject("Sem internet");
          return;
        }

        if (ShowLoading) {
          this.showLoading();
        }
        this.http.post(url, dados, httpOption).toPromise()
          .then(async (result: any) => {
            if (callbackfunction != undefined) {
              // Esse parametro mostra todos os dados que trafegam pela API, deixar como false em base de produção
              result.mostraRetorno = mostraRetorno;
              await callbackfunction(result);
            }
            if (ShowLoading) {
              setTimeout( () => {
                this.hideLoading();
                // LoadingComponent.Hide();
              }, 500); //RETORNAR PARA 500 MILESIMOS - 1000 PARA TESTE COM LIVE SHARE VSCODE
            }
            Promise.resolve(result);

          })
          .catch(async (error:any) => {
            console.log(error)
            if (ShowLoading) {
              setTimeout( () => {
              this.hideLoading();
              }, 500);
            }
            var ErrorMsg = "";
            if (error.error instanceof ErrorEvent) {
              ErrorMsg = error.error.text;
              this.showError(ErrorMsg)
            } else {
              let ErrorSession = error.error
              if(typeof(ErrorSession) != 'object'){
                ErrorSession = JSON.parse(ErrorSession.trim())
              }
              if(typeof(ErrorSession.session) != undefined && ErrorSession.session == false){

                var login = await JSON.parse(this.localStorage.getData("LOGIN"))
                this.APIauth.getFromApi("login", {...login}, (Retorno:any) =>{
                  this.localStorage.setData('SESSION', Retorno.access_token);
                  this.getFromApi(funcao, metodo, dados, callbackfunction, ShowLoading, ApiUrl)
                },false,"");
                
              }else{
                if(typeof(error) == 'object'){
                  if(typeof(error.error) == 'object'){
                      ErrorMsg = error.error.text;
                  }else{
                    ErrorMsg = error.error;
                  }
                }else{
                  ErrorMsg = error;
                }
                this.showError(ErrorMsg)
              }
            }
          });
      })
    })
  }

}
